import { render, staticRenderFns } from "./ci_resource_readme.vue.js?vue&type=template&id=1b8596f6&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_resource_readme.vue?vue&type=template&id=1b8596f6&vue3"
import script from "./ci_resource_readme.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_resource_readme.vue?vue&type=script&lang=js&vue3"
export * from "./ci_resource_readme.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_resource_readme.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports